/* =========================================================================
   My Prolearning — Bundle pages: keep the user on-site after the bundle is
   added to cart. Intercepts the third-party Bundler app's /cart/add calls
   (fetch + XHR), refreshes and OPENS the themed cart drawer, and best-effort
   suppresses the app's redirect to /cart or /checkout so the flow stays fluid.
   Pure interception — we never modify the app's DOM or logic.
   NOTE: a hard `location.href = '/checkout'` from the app can only be stopped
   in the app's own settings; everything else is handled here.
   ========================================================================= */
(function () {
  "use strict";
  if (window.__mplBundleCart) return;            // (1) idempotent guard
  window.__mplBundleCart = true;

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/i;
  var NAV_RE = /\/(cart|checkout)(\/|\?|$)/i;
  var lastAdd = 0, opening = false;

  function recentAdd() { return Date.now() - lastAdd < 2600; }   // (2) redirect window

  /* (3) refresh + open the themed drawer (graceful fallback) */
  function openDrawer() {
    if (opening) return; opening = true;
    setTimeout(function () { opening = false; }, 400);           // (4) debounce bursts
    try {
      if (window.MPLChrome && window.MPLChrome.refresh) {
        window.MPLChrome.refresh().then(function () {
          if (window.MPLChrome.openCart) window.MPLChrome.openCart();   // (5) open drawer
        }).catch(function () {});
        return;
      }
    } catch (e) {}
    /* (6) fallback: no drawer available -> go to cart (still no checkout) */
    try { window.location.assign("/cart"); } catch (e) {}
  }

  function noteAdd() { lastAdd = Date.now(); setTimeout(openDrawer, 160); }  // (7) after add settles

  /* (8) intercept fetch() for /cart/add */
  if (typeof window.fetch === "function") {
    var of = window.fetch;
    window.fetch = function () {
      var a0 = arguments[0];
      var url = a0 && (typeof a0 === "string" ? a0 : a0.url) || "";
      var p = of.apply(this, arguments);
      if (ADD_RE.test(url)) {
        try { p.then(function (r) { if (!r || r.ok) noteAdd(); }).catch(function () {}); } catch (e) {}  // (9) only on success
      }
      return p;
    };
  }

  /* (10) intercept XMLHttpRequest for /cart/add */
  try {
    var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__mplUrl = u; return oOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (x.__mplUrl && ADD_RE.test(String(x.__mplUrl))) {
        x.addEventListener("load", function () { if (x.status >= 200 && x.status < 300) noteAdd(); }); // (11)
      }
      return oSend.apply(this, arguments);
    };
  } catch (e) {}

  /* (12) best-effort: cancel programmatic redirects to cart/checkout right after an add */
  try {
    var la = window.location.assign.bind(window.location);
    var lr = window.location.replace.bind(window.location);
    window.location.assign = function (u) { if (recentAdd() && NAV_RE.test(String(u))) { openDrawer(); return; } return la(u); };
    window.location.replace = function (u) { if (recentAdd() && NAV_RE.test(String(u))) { openDrawer(); return; } return lr(u); };
  } catch (e) {}

  /* (13) intercept clicks on checkout/cart links inside the bundle widget */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (!a) return;
    if (!(a.closest && a.closest("#__pf"))) return;             // (14) only inside the PageFly bundle page
    var href = a.getAttribute("href") || "";
    if (/\/checkout(\/|\?|$)/i.test(href) || /\/cart(\/|\?|$)/i.test(href)) {
      e.preventDefault();                                       // (15) stay on site
      e.stopPropagation();
      openDrawer();
    }
  }, true);

  /* (16) intercept form submits that would navigate to cart/checkout (within the widget) */
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || !f.action) return;
    if (!(f.closest && f.closest("#__pf"))) return;
    if (NAV_RE.test(String(f.action)) && f.method && f.method.toLowerCase() === "get") {
      e.preventDefault();
      openDrawer();
    }
  }, true);
})();
